import {connect} from "react-redux"
import {createSelector} from "reselect"
import {State} from "ducks"
import {deleteRecentQueries} from "../../../../ducks/recents"

const textSelector = createSelector(
    (state: State) => state.text,
    text => {
        const {
            recentSearches: {simple, clearAllButton},
        } = text
        return {...simple, clearAllButton}
    },
)
export const mapStateToProps = (state: State) => {
    const {
        recents: {queryIds},
    } = state

    const showClearAll = queryIds && queryIds.length > 0

    return {
        text: textSelector(state),
        showClearAll,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    clear: () => {
        dispatch(deleteRecentQueries())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
